var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full h-full fixed left-0 top-0 alarm z-9999 pointer-events-none",style:({ opacity: _vm.alarmOpacity ? 1 : 0, transition: ("opacity " + (_vm.frequency / 1000) + "s") })})}
var staticRenderFns = []

export { render, staticRenderFns }